import { Pagination } from "antd";
import { BILLING_DEFAULT_PAGE_SIZE } from "./billingPaginationUtils";

interface BillingInvoicePaginationProps {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number, pageSize: number) => void;
  disabled?: boolean;
}

const BillingInvoicePagination = ({
  current,
  pageSize,
  total,
  onChange,
  disabled = false,
}: BillingInvoicePaginationProps) => {
  if (total <= 0) {
    return null;
  }

  return (
    <div className="flex items-center justify-end border-t p-4">
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={(page, size) => {
          if (size && size !== pageSize) {
            onChange(1, size);
            return;
          }

          onChange(page, pageSize);
        }}
        onShowSizeChange={(_current, size) => {
          onChange(1, size);
        }}
        showSizeChanger
        showQuickJumper
        showTotal={(totalCount, range) =>
          `${range[0]}-${range[1]} of ${totalCount} items`
        }
        pageSizeOptions={["50", "100", "200", "300", "500"]}
        defaultPageSize={BILLING_DEFAULT_PAGE_SIZE}
        disabled={disabled}
      />
    </div>
  );
};

export default BillingInvoicePagination;
